import { toast } from "sonner";
import { Mail, CalendarPlus, Unlock } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const EmailToggle = ({ field, endpoint, icon: Icon, title, desc, testid, className = "" }) => {
  const { user, setUser } = useAuth();
  const on = user[field] !== false;
  const change = async (value) => {
    try {
      await api.put(endpoint, { value });
      setUser({ ...user, [field]: value });
      toast.success(value ? "Avvisi email attivati" : "Avvisi email disattivati");
    } catch (e) { toast.error(formatApiError(e)); }
  };
  return (
    <label className={`flex items-center justify-between gap-6 border border-white/10 bg-[#121418] px-6 py-5 cursor-pointer ${className}`} data-testid={`${testid}-toggle`}>
      <span className="flex items-start gap-3">
        <Icon className="w-4 h-4 text-[#D4AF37] mt-0.5" />
        <span>
          <span className="block text-sm text-neutral-200">{title}</span>
          <span className="block text-xs text-neutral-500 mt-1">{desc(user)}</span>
        </span>
      </span>
      <Switch checked={on} onCheckedChange={change} data-testid={`${testid}-switch`} />
    </label>
  );
};

export const ChatEmailToggle = () => (
  <EmailToggle field="chat_emails" endpoint="/me/chat-emails" icon={Mail} testid="chat-email" className="mt-10"
    title="Avvisi email per i nuovi messaggi" desc={(u) => `Ti scriviamo a ${u.email} quando ricevi un messaggio e non sei sull'app.`} />
);

export const EventEmailToggle = () => (
  <EmailToggle field="event_emails" endpoint="/me/event-emails" icon={CalendarPlus} testid="event-email" className="mt-4"
    title="Avvisi email per gli eventi vicini" desc={(u) => `Ti scriviamo a ${u.email} quando viene pubblicato un evento entro 100 km dal tuo comune.`} />
);

export const UnlockEmailToggle = ({ className = "mt-4", testid = "unlock-email" }) => (
  <EmailToggle field="unlock_emails" endpoint="/me/unlock-emails" icon={Unlock} testid={testid} className={className}
    title="Avvisi email quando sbloccano i tuoi contatti" desc={(u) => `Ti scriviamo a ${u.email} quando un cliente sblocca il tuo profilo.`} />
);
